import FeedbackPage from '@/components/FeedbackPage'

export default function InvestmentReminderPage() {
  return (
    <FeedbackPage
      emoji="💪"
      title="pages.onboarding.investmentReminder.title"
    />
  )
}
